"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledDesc = exports.StyledButtonHolder = exports.StyledBanner = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _media = _interopRequireDefault(require("../lib/media"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var StyledBanner = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 20px;\n  box-sizing: border-box;\n  ", "\n  background: ", ";\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  transition: box-shadow 0.2s ease-in-out;\n  ", "\n  ", "\n\n  .banner-content {\n    display: flex;\n    align-items: center;\n    flex: 1;\n  }\n\n  ", "\n"])), _styledSystem.space, function (props) {
  return (0, _utils.getPalette)(props.color, 'c05')(props);
}, function (props) {
  return (0, _utils.getBorderRadius)('tertiary')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right; flex-direction: row-reverse;";
}, function (props) {
  return props.shadow && "box-shadow: ".concat((0, _utils.getShadow)(2)(props));
}, _media["default"].small(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: column;\n  "]))));

exports.StyledBanner = StyledBanner;

var StyledIcon = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-right: 12px;\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return (0, _utils.getPalette)(props.color, 'c02')(props);
});

exports.StyledIcon = StyledIcon;

var StyledDesc = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  color: ", ";\n  padding-right: 14px;\n  box-sizing: border-box;\n  flex: 1;\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('bodySmall')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c04')(props);
}, _media["default"].small(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 0px;\n  "]))));

exports.StyledDesc = StyledDesc;

var StyledButtonHolder = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n"])), _media["default"].small(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    margin-top: 8px;\n  "]))));

exports.StyledButtonHolder = StyledButtonHolder;